<template>
  <span class="convenience-fee">*A {{ fee }}% convenience fee will be added to credit cards and digital wallets. To pay
    without the fee, consider Zelle, ACH, or Wire Transfer.</span>
</template>
  
<script>
export default {
  name: "ConvenienceFeeMessageComponent",
  props: {
    fee: {
      type: Number,
      default: 3,
    },
  },
};
</script>